export default {
  productType: {
    en: 'Buy Your Queue item',
  },
}
